import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import './EventTitle.css';
import { API_BASE_URL } from '../utils/apiBase';

const EventTitle = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Extract event path from URL
  const eventPath = location.pathname.split('/')[1];

  const fetchEventData = useCallback(async () => {
    try {
      if (eventPath && eventPath !== '') {
        // Try to fetch event-specific data first
        try {
          const eventResponse = await fetch(`${API_BASE_URL}/events/by-path/${eventPath}`);
          if (eventResponse.ok) {
            const event = await eventResponse.json();
            setConfig({
              eventTitle: event.name,
              eventLogo: event.event_settings?.branding?.logo_url || null
            });
            setLoading(false);
            return;
          }
        } catch (eventError) {
          console.log('Event-specific data not found, falling back to global config');
        }
      }

      // Fall back to global config
      const response = await fetch(`${API_BASE_URL}/event-config`);
      const data = await response.json();
      setConfig(data);
    } catch (error) {
      console.error('Error fetching config:', error);
      // Use default config if API fails
      setConfig({
        eventTitle: eventPath ? `Welcome to ${eventPath}!` : 'Welcome to Our Event!',
        eventLogo: null
      });
    } finally {
      setLoading(false);
    }
  }, [eventPath]);

  useEffect(() => { fetchEventData(); }, [fetchEventData]);

  if (loading) {
    return (
      <header className="welcome-header">
        <h1>🎉 Loading...</h1>
        <p>Please wait...</p>
      </header>
    );
  }

  return (
    <header className="welcome-header">
      {config?.eventLogo && (
        <div className="event-logo">
          <img src={config.eventLogo} alt="Event Logo" />
        </div>
      )}
      <h1>🎉 {config?.eventTitle || 'Welcome to Our Event!'}</h1>
      <p>Please check in below to find your seat</p>
    </header>
  );
};

export default EventTitle;
